<template>
  <div id="devicePlayer">
    <div style="position: relative; top: -20px">
      <span class="transfer-close" @click="close" style="position: absolute"
        ><i>X</i>关闭</span
      >
    </div>
    <llycvr
      ref="videoPlayer"
      :visible.sync="showVideoDialog"
      :videoUrl="videoUrl"
      :hasAudio="hasAudio"
      height="false"
      error="失败error"
      message="失败message"
      fluent
      autoplay
      live
    ></llycvr>
  </div>
</template>

<script>
let _this;
import llycvr from "./llycvr.vue";
export default {
  name: "devicePlayer",
  props: {},
  components: {
    llycvr,
  },
  computed: {},
  created() {
    _this = this;
  },
  data() {
    return {
      tabActiveName: "media",
      channelId: "",
      deviceId: "",
      videoUrl: "", //当前使用的视频地址
      streamId: "",
      mediaServerId: "",
      app: "",
      showVideoDialog: false,
      videoError: "",
      hasAudio: "",
    };
  },
  methods: {
    openDialog(tab, deviceId, channelId, param) {
      _this.tabActiveName = tab;
      _this.channelId = channelId;
      _this.deviceId = deviceId;
      _this.streamId = "";
      _this.mediaServerId = "";
      _this.app = "";
      _this.videoUrl = "";

      if (!!_this.$refs.videoPlayer) {
        _this.$refs.videoPlayer.pause();
      }
      switch (tab) {
        case "media":
          _this.play(param.streamInfo, param.hasAudio);
          break;
        case "record":
          _this.showVideoDialog = true;
          _this.backPlay(param.streamInfo);
          break;
        case "streamPlay":
          _this.play(param.streamInfo, param.hasAudio);
          break;
        case "control":
          break;
      }
    },

    backPlay(res) {
      var streamInfo = res;
      _this.app = streamInfo.app;
      _this.streamId = streamInfo.streamId;
      _this.mediaServerId = streamInfo.mediaServerId;
      _this.videoUrl = _this.getUrlByStreamInfo(streamInfo);
    },

    play(streamInfo, hasAudio) {
      _this.hasAudio = hasAudio;
      _this.videoUrl = _this.getUrlByStreamInfo(streamInfo);
      _this.streamId = streamInfo.streamId;
      _this.app = streamInfo.app;
      _this.mediaServerId = streamInfo.mediaServerId;
      _this.playFromStreamInfo(false, streamInfo);
    },

    playFromStreamInfo(realHasAudio, streamInfo) {
      _this.showVideoDialog = true;
      _this.hasaudio = realHasAudio && _this.hasaudio;
      _this.$refs.videoPlayer.play(_this.getUrlByStreamInfo(streamInfo));
    },
    // 全屏
    fullscreen() {
      this.$refs.videoPlayer.fullscreenSwich();
    },
    getUrlByStreamInfo(streamInfo) {
      let baseZlmApi =
      process.env.NODE_ENV === "development"
        ? `${location.host}/debug/zlm`
        : `${location.host}/zlm`;
      // 修复更新link后，视频无法加载问题这个要用flv格式的
      let newPlayurl;
      let plyerUrl = streamInfo.flv;
      let linkcvrStatus = plyerUrl.indexOf("http://114.242.16.189:809");
      let linkCvr1Url = plyerUrl.replace(
        "http://114.242.16.189:808",
        "https://qinwu.00e.com"
      );
      let linkCvr2Url = plyerUrl.replace(
        "http://114.242.16.189:809",
        "https://zlm2.00e.com:444"
      );
      // 判断是link1还是link2
      linkcvrStatus > -1 ? (newPlayurl = linkCvr2Url) : (newPlayurl = linkCvr1Url);
      return newPlayurl.replace(':810/', '/').replace('http://', 'https://');
    },

    close() {
      console.log("关闭视频");
      if (!!_this.$refs.videoPlayer) {
        _this.$refs.videoPlayer.pause();
      }
      _this.videoUrl = "";
      _this.showVideoDialog = false;
      //父级关闭
      _this.$emit("close");
    },
  },
};
</script>

<style lang="less" scoped>
.transfer-close {
  position: absolute;
  right: 0;
  color: #fff;
  top: 0px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0);
  border-radius: 4px;
  padding: 3px 8px;
  font-size: 12px;
  i {
    font-style: normal;
    padding: 0px 5px 0px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/transferView/devicePlayer.vue